import { nextTick } from "vue";

export const usePageTitle = () => {
  const updateTitle = async (route) => {
    const default_title = "ASKO";
    await nextTick();
    document.title = route.meta.title ? `${route.meta.title} | ${default_title}` : default_title;
  };

  return { updateTitle };
};
